declare function ancre_douce_init(): void;
declare function blocs_init(): void;
declare function parametre_url(
  url: string,
  c: string,
  v?: string,
  sep?: string,
  force_vide?: boolean
): void;

declare global {
  interface JQuery {
    scrollTo: (...args: any[]) => void;
  }

  interface JQueryStatic {
    modalbox?: (...args: any[]) => void;
  }
}

export type TLEvent = Event & {
  data?: any;
};

export const TL = {
  start: () => {
    window.Turbolinks = require("turbolinks");
    window.Turbolinks.start();
    window.Turbolinks.setProgressBarDelay(300);

    /* Quand il y a un hash dans l'url, on scolle… */
    TL.bind("load", () => {
      const url = new URL(window.location.toString());
      $(window).scrollTo(url.hash, { duration: 500 });
    });

    /* Compatibilité avec le plugin ancres douces */
    window.addEventListener("load", function () {
      window.addEventListener("tdm:loaded", ancre_douce_init);
    });

    /* Compatibilité avec fancybox */
    window.addEventListener("load", function () {
      $.fancybox.defaults.loop = true;
      // Disable history API calls that mess with turbolinks.
      $.fancybox.defaults.hash = false;
    });

    /* Compatibilité avec le plugin blocsdepliables */
    window.addEventListener("load", () => {
      TL.bind("load", () => {
        blocs_init.apply(document);
        blocs_init();
      });
    });

    /* Compatibilité avec les popins */
    let $colorboxOverlay: JQuery<HTMLElement> | null,
      $colorbox: JQuery<HTMLElement> | null;
    window.addEventListener("load", () => {
      TL.bind("before-visit", () => {
        $colorboxOverlay = $("#cboxOverlay");
        $colorbox = $("#colorbox");
      });

      TL.bind("load", () => {
        $colorboxOverlay?.appendTo("body");
        $colorbox?.appendTo("body");

        $("a.popin", this).on("click", function () {
          let href = parametre_url(
            (this as HTMLAnchorElement).href,
            "var_zajax",
            $(this).attr("data-var_zajax")
              ? $(this).attr("data-var_zajax")
              : "content"
          );
          if ($.modalbox) {
            $.modalbox(href);
          }
          return false;
        });
      });
    });
  },

  bind: (tl_event: string, func: EventListenerOrEventListenerObject) => {
    window.addEventListener("turbolinks:" + tl_event, func);
  },

  unbind: (tl_event: string, func: EventListenerOrEventListenerObject) => {
    window.removeEventListener("turbolinks:" + tl_event, func);
  },
};
